<template>
    <div class="pages">
        <div class="navcnetbox">
            <div class="logo">
                <img src="../../assets/img/index/logo.svg" alt="" />
                <span>完善个人信息</span>
            </div>
            <div class="registerbox">
                <!-- 图片上传 -->
                <van-uploader multiple :after-read="afterRead">
                    <van-button icon="plus" type="primary">
                        <div>个人图片</div>
                        <img src="../../assets/img/login/tx_img.png" alt="" />
                    </van-button>
                </van-uploader>
                <!-- 用户信息 -->
                <div class="peopmession">
                    <p>姓名</p>
                    <input type="text" name="" id="" placeholder="请输入姓名" />
                    <p>身份证号</p>
                    <input type="text" name="" id="" placeholder="请输入身份证号" />
                    <p>学历</p>
                    <input type="text" name="" id="" placeholder="请输入学历" />
                    <p>手机号</p>
                    <input type="text" name="" id="" placeholder="请输入手机号" />
                </div>
            </div>
            <div class="submit">确认提交</div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import { Uploader } from 'vant';

Vue.use(Uploader);
export default {
    data() {
        return {
            // fileList: [
            //     {
            //         url: 'https://img01.yzcdn.cn/vant/leaf.jpg',
            //         status: 'uploading',
            //         message: '上传中...',
            //     },
            //     {
            //         url: 'https://img01.yzcdn.cn/vant/tree.jpg',
            //         status: 'failed',
            //         message: '上传失败',
            //     },
            // ],
        };
    },
    methods: {
        afterRead(file) {
            // 此时可以自行将文件上传至服务器
            console.log(file);
        },
    },
};
</script>
<style lang="less" scoped>
     // 背景
     .pages {
         background: url(../../assets//img/login/wsgrxx.jpg) no-repeat;
         background-size: 100% 100%;
         background-position: center center;
         width: 100%;
         height: 100%;
         background-size: cover;
         position: fixed;
         top: 0;
         left: 0;
         right: 0;
         bottom: 0;
         .navcnetbox {
             position: fixed;
             top: 50%;
             left: 50%;
             transform: translate(-50%, -50%);
             background: #ffffff;
             padding: 40px 60px 0 46px;
             box-shadow: -7px 3px 13px 1px rgba(255, 237, 207, 0.4588235294117647);
             border-radius: 30px 30px 30px 30px;
             .logo {
                 display: flex;
                 justify-content: space-between;
                 align-items: center;
                 width: 700px;
                 img {
                     width: 300px;
                     height: 64px;
                 }
                 span {
                     font-size: 32px;
                     color: #fd6905;
                 }
             }
             .registerbox {
                 margin-top: 64px;
                 display: flex;
                 justify-content: space-between;
                 van-button {
                     div {
                         font-size: 16px;
                         color: #909090;
                         margin-bottom: 17px;
                     }
                     img {
                         width: 82px;
                         height: 82px;
                     }
                 }
                 .peopmession {
                     p {
                         font-size: 16px;
                         color: #909090;
                         line-height: 30px;
                     }
                     input {
                         line-height: 30px;
                         width: 415px;
                         border: none;
                         margin-bottom: 10px;
                         border-bottom: 1px solid #d7d7d7;
                         b &::placeholder {
                             font-size: 16px;
                             color: #484545;
                         }
                     }
                 }
             }
             .submit {
                 width: 415px;
                 height: 45px;
                 line-height: 45px;
                 text-align: center;
                 margin: 100px auto 152px;
                 border-radius: 60px;
                 background: linear-gradient(to right, #f4a223, #ff6000);
                 font-size: 16px;
                 color: #ffffff;
             }
         }
     }
     
</style> 